import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { NetworkAppContainerConsoleDataProvider } from '../dataProvider/NetworkAppContainerConsoleDataProvider';

export class NetworkAppContainerDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, NetworkAppContainerConsoleDataProvider);
  }
}
